import type { Ref } from 'vue'
import { ROUTE_CART } from '@/router'
import type { CombinedError } from '@urql/vue'
import type { ResponseData } from '@/composables/app/useHandleFormSubmitResponse'
import { useHandleFormSubmitResponse } from '@/composables/app/useHandleFormSubmitResponse'
import { useSegmentProductAnalytics } from '@/views/product/composables/analytics/useSegmentProductAnalytics'
import type { ProductAnalyticsFragment } from '@/graphql/api'
import type { RingBuilder } from '@/plugins/ring-builder.ts'
import { useSegment } from '@/third-party/segment.ts'

type AddToCartResponseData = {
    data: ResponseData | undefined
    error: CombinedError | undefined
}

interface HandleAddToCartSuccess {
    prepare(): ({ error, data }: AddToCartResponseData) => void
}

export function useHandleAddToCartSuccess(
    ring: Readonly<Ref<ProductAnalyticsFragment | undefined | null>>,
    ringBuilder?: Readonly<Ref<RingBuilder | undefined>>
): HandleAddToCartSuccess {
    const { track } = useSegment()
    const serialize = useSegmentProductAnalytics()

    const { handleFormSubmitResponse } = useHandleFormSubmitResponse(ROUTE_CART)

    // TODO check if should redirect to design studio

    // Prepare fn - saves snapshot from data so it won't change later. (Mutations from API changes the data)
    const prepare = () => {
        const ringValue = ring.value
        const ringBuilderValue = ringBuilder?.value

        const serialized = ringValue
            ? serialize(ringValue, ringBuilderValue)
            : null

        return ({ error, data }: AddToCartResponseData) => {
            if (error || !data) {
                return
            }

            if (serialized) {
                track('Product Added', serialized)
            }

            handleFormSubmitResponse(data)
        }
    }

    return { prepare }
}
